import { useTheme } from '@mui/joy';
import { useSnackbar } from 'notistack';

/**
 * Custom hook to display notifications using the `useSnackbar` hook.
 * this hook overrides the default `enqueueSnackbar` function to display notifications with custom styles.
 */
function useNotification() {
	const theme = useTheme();
	const { enqueueSnackbar } = useSnackbar();

	const showNotification = (message: string, options: { variant: 'success' | 'error' }) => {
		switch (options.variant) {
			case 'success':
				showSuccessNotif(message);
				break;
			case 'error':
				showErrorNotif(message);
				break;
			default:
				break;
		}
	};

	const showSuccessNotif = (message: string) => {
		enqueueSnackbar(message, {
			style: {
				backgroundColor: theme.palette.success.softBg,
				color: theme.palette.success.softColor,
				boxShadow: 'none',
			},
			variant: 'success',
		});
	};

	const showErrorNotif = (message: string) => {
		enqueueSnackbar(message, {
			style: {
				backgroundColor: theme.palette.danger.softBg,
				color: theme.palette.danger.softColor,
				boxShadow: 'none',
			},
			variant: 'error',
		});
	};

	return {
		showNotification,
	};
}

export default useNotification;
